export namespace LuckySpinId {
  export function idToGameName(id: bigint): string {
    switch (id?.toString()) {
      default:
      case '1':
        return 'Bronze';
      case '2':
        return 'Gold';
      case '3':
        return 'Ruby';
    }
  }
}
